import styled from 'styled-components';
import { BannerBodyBase } from 'ui/banner/Banner.styles';
import { InfoFill16 } from 'ui/icons';
import { caption, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const JourneyVisitorBreakdownContainer = styled.div`
  display: flex;
  height: 72px;
  padding: ${pxToRem(14)} ${spacing.base};
  align-items: center;
  gap: ${spacing.half};
  align-self: stretch;
  justify-content: space-between;
  border-color: ${colors.grey15};
  border-style: solid;
  border-width: 2px;
`;

export const JourneyVisitorActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing.half}
`;

export const StyledBannerBodyBase = styled(BannerBodyBase)`
  display: flex;
  align-items: center;
  gap: ${spacing.half}
`;

export const StyledInfoIcon = styled(InfoFill16)`
  > path { 
    fill: ${colors.iconInfo};
  }
`;

export const StyledCellContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.quarter};
  align-self: stretch;
`;

export const CellSecondaryText = styled.div`
  ${caption};
  ${colors.textSecondary}
`;
